import filter from 'lodash/filter';
import map from 'lodash/map';

export const parseUserGroup = userGroup => {
    const defaultRole = filter(userGroup.Roles, ['Role', '1']);

    return {
        GroupId: userGroup.GroupId,
        Name: userGroup.Description,
        Description: userGroup.ExtraDescription,
        PictureURL: userGroup.PictureURL,
        Extension: defaultRole[0] ? +defaultRole[0].ExtraData.DefaultExtension : '',
        RecordingCapacity: defaultRole[0] ? +defaultRole[0].ExtraData.RecordingCapacity : '',
        RingTime: defaultRole[0] ? +defaultRole[0].ExtraData.DefaultRings : 30,
        Strategy: defaultRole[0] ? defaultRole[0].ExtraData.GroupType : 1,
        Recording: defaultRole[0] ? defaultRole[0].ExtraData.Monitor : 0,
        MusicOnHold: defaultRole[0] ? defaultRole[0].ExtraData.Moh : 'none',
        HasRole: defaultRole.length > 0
    };
};

export const parseMembers = members => map(members, member => ({
    ...member,
    UserId: member.Entity
}));
